import { render } from "./HeroSearchBar.vue?vue&type=template&id=07866f7c"
import script from "./HeroSearchBar.vue?vue&type=script&lang=js"
export * from "./HeroSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__